var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "上传图片制作印章",
        visible: _vm.diaVisi,
        width: _vm.responsiveValue,
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.diaVisi = $event
        }
      }
    },
    [
      _c(
        "el-row",
        { staticClass: "row-box", attrs: { gutter: 5 } },
        [
          _c("el-col", { staticClass: "pub-sty", attrs: { span: 7 } }, [
            _c("div", { staticClass: "first" }, [
              _c("p", { staticClass: "m-b-10" }, [_vm._v("一、上传图片")]),
              _c(
                "div",
                { staticClass: "first-content" },
                [
                  _vm.sealImgBase64
                    ? [
                        _c(
                          "div",
                          { staticClass: "seal-creat flex-col-center" },
                          [
                            _c("img", {
                              ref: "sealCreateRef",
                              attrs: { src: _vm.sealImgBase64, alt: "" }
                            })
                          ]
                        ),
                        _c("div", { staticClass: "option" }, [
                          _c(
                            "div",
                            { staticClass: "option-tool flex-around" },
                            [
                              _c("i", {
                                staticClass: "el-icon-refresh-left",
                                on: {
                                  click: function($event) {
                                    return _vm.rotateSeal(-1)
                                  }
                                }
                              }),
                              _c("i", {
                                staticClass: "el-icon-refresh-right",
                                on: {
                                  click: function($event) {
                                    return _vm.rotateSeal(1)
                                  }
                                }
                              }),
                              _c("i", {
                                staticClass: "el-icon-zoom-out",
                                on: {
                                  click: function($event) {
                                    return _vm.scaleZoom("out")
                                  }
                                }
                              }),
                              _c("i", {
                                staticClass: "el-icon-zoom-in",
                                on: {
                                  click: function($event) {
                                    return _vm.scaleZoom("in")
                                  }
                                }
                              }),
                              _c(
                                "span",
                                { staticClass: "re-upload" },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        action: "",
                                        accept: "image/*",
                                        limit: 1,
                                        "before-upload": _vm.beforeSealUpload,
                                        "show-file-list": false
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-upload2"
                                      }),
                                      _vm._v("重新上传\n                    ")
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c("div", { staticClass: "flex-between" }, [
                            _c("span", [_vm._v("角度")]),
                            _c(
                              "div",
                              { staticStyle: { width: "70%" } },
                              [
                                _c("el-slider", {
                                  attrs: { size: "small", min: -180, max: 180 },
                                  on: { input: _vm.realRotation },
                                  model: {
                                    value: _vm.sealOption.scale,
                                    callback: function($$v) {
                                      _vm.$set(_vm.sealOption, "scale", $$v)
                                    },
                                    expression: "sealOption.scale"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ]
                    : [
                        _c(
                          "div",
                          { staticClass: "seal-creat flex-col-center" },
                          [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "",
                                  accept: "image/*",
                                  limit: 1,
                                  "before-upload": _vm.beforeSealUpload,
                                  "show-file-list": false
                                }
                              },
                              [
                                _c("div", [
                                  _c("i", {
                                    staticClass: "el-icon-plus icon-sty"
                                  }),
                                  _c("p", [_vm._v("点击上传签章图片")])
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ]
                ],
                2
              )
            ])
          ]),
          _c("el-col", { staticClass: "pub-sty second", attrs: { span: 9 } }, [
            _c(
              "div",
              { staticClass: "second-body" },
              [
                _c("p", { staticClass: "m-b-10" }, [_vm._v("二、印章设置")]),
                _c("p", { staticClass: "m-b-10 m-t-distance text-color" }, [
                  _vm._v("印章颜色")
                ]),
                _c(
                  "el-radio-group",
                  {
                    staticClass: "color-radio",
                    on: { input: _vm.sealColorChange },
                    model: {
                      value: _vm.sealAttri.color,
                      callback: function($$v) {
                        _vm.$set(_vm.sealAttri, "color", $$v)
                      },
                      expression: "sealAttri.color"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: -1 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "color-item-sty",
                          class: {
                            "select-none-sty": !!(_vm.sealAttri.color == -1)
                          }
                        },
                        [
                          _c("div", { staticClass: "seal-dome-none" }, [
                            _c("span", { staticClass: "none-sty" })
                          ])
                        ]
                      )
                    ]),
                    _c("el-radio", { attrs: { label: 1 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "color-item-sty",
                          class: { "select-sty": !!(_vm.sealAttri.color == 1) }
                        },
                        [_c("div", { staticClass: "seal-dome red" })]
                      )
                    ]),
                    _c("el-radio", { attrs: { label: 2 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "color-item-sty",
                          class: { "select-sty": !!(_vm.sealAttri.color == 2) }
                        },
                        [_c("div", { staticClass: "seal-dome blue" })]
                      )
                    ]),
                    _c("el-radio", { attrs: { label: 3 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "color-item-sty",
                          class: { "select-sty": !!(_vm.sealAttri.color == 3) }
                        },
                        [_c("div", { staticClass: "seal-dome black" })]
                      )
                    ])
                  ],
                  1
                ),
                _c("div"),
                [
                  _c(
                    "p",
                    { staticClass: "m-b-10 m-t-distance" },
                    [
                      _vm._v("背景透明度 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "数值越大则去除印章背景效果越强",
                            placement: "right"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("el-slider", {
                        attrs: { size: "small", min: 1, max: 255 },
                        on: { change: _vm.bgattrs },
                        model: {
                          value: _vm.sealAttri.range,
                          callback: function($$v) {
                            _vm.$set(_vm.sealAttri, "range", $$v)
                          },
                          expression: "sealAttri.range"
                        }
                      })
                    ],
                    1
                  )
                ]
              ],
              2
            )
          ]),
          _c("el-col", { staticClass: "pub-sty", attrs: { span: 8 } }, [
            _c("div", { staticClass: "third" }, [
              _c(
                "div",
                { ref: "previewRef" },
                [
                  _c("div", { staticClass: "prview-img" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.cropedImg,
                        alt: "效果",
                        width: _vm.convertWidth + "px",
                        height: _vm.convertHeight + "px"
                      }
                    })
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.userType == 1,
                          expression: "userType ==1"
                        }
                      ]
                    },
                    [
                      _c("p", [_vm._v("1.请保证印章清晰、完整可见；")]),
                      _c("p", [_vm._v("2.印章请紧贴四周，避免过多留白。")])
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "confirm-btn",
                      attrs: {
                        type: "primary",
                        loading: _vm.loading,
                        size: "small"
                      },
                      on: { click: _vm.handCreatedSeal }
                    },
                    [_vm._v("确 定\n            ")]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ef1cdd3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef1cdd3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/tpl-editor/userLocalSeal.vue
// module id = uXTC
// module chunks = 12 13 29 75